import {useTranslation} from 'react-i18next';
import {useTheme} from 'styled-components';
import checkedCircleIcon from 'assets/icons/checkedCircle.svg';
import questionAlertCircleIcon from 'assets/icons/questionAlertCircle.svg';
import ModalSheet from 'components/common/ModalSheet';
import {ProgressTaskBar} from '../ProgressTaskBar';
import {ShareRegistrationLinkButton} from 'components/ShareRegistrationLinkButton';
import {Button, CustomIcon} from '@guestapp/ui';
import {getMainColor} from 'styled/common';
import styles from './styles.module.css';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  registeredGuests?: number;
  pendingGuests?: number;
  onRegisterNext?: () => void;
  onGoHome?: () => void;
}

function RegisteredGuestsInfoModal({
  isOpen,
  onClose,
  registeredGuests = 1,
  pendingGuests = 3,
  onRegisterNext,
  onGoHome,
}: Props) {
  const theme = useTheme();
  const {t} = useTranslation();
  const totalGuests = registeredGuests + pendingGuests;

  return (
    <ModalSheet
      isOpenModalSheet={isOpen}
      handleCloseModal={onClose}
      withCloseButton
      withModalMobileCloseButton
      closeOnDocumentClick={false}
      closeButtonType="slide"
      closeOnEscape={false}
      className={styles.modalSheet}
    >
      <div className={styles.container}>
        <ProgressTaskBar
          completed={registeredGuests}
          total={totalGuests}
          title="Registered guests"
          icon={<CustomIcon name="multiGuest" size="24" />}
        />

        <div className={styles.statusContainer}>
          <div className={styles.statusItem}>
            <div className={styles.statusIcon}>
              <img src={checkedCircleIcon} alt="success" width={24} height={24} />
            </div>
            <span className={styles.statusText}>
              {registeredGuests}{' '}
              <span>{registeredGuests !== 1 ? t('guests') : t('guest')}</span>{' '}
              {t('registered_successfully')}
            </span>
          </div>

          <div className={styles.statusItem}>
            <div className={styles.statusIcon}>
              <img src={questionAlertCircleIcon} alt="pending" width={24} height={24} />
            </div>
            <span className={styles.statusText}>
              {pendingGuests}{' '}
              <span>{pendingGuests !== 1 ? t('guests') : t('guest')}</span>{' '}
              {t('pending_registration')}
            </span>
          </div>
        </div>

        <div className={styles.buttonContainer}>
          <Button
            label={t('register_next_guest')}
            onClick={onRegisterNext}
            customIcon={<CustomIcon name="addGuestTwo" size="24" color="#fff" />}
            className={styles.homeButton}
            iconProps={{position: 'left'}}
          />
          <Button
            label={t('go_to_home')}
            outlined
            onClick={onGoHome}
            customIcon={<CustomIcon name="home" size="24" color={getMainColor(theme)} />}
            className={styles.homeButton}
            iconProps={{position: 'left'}}
          />
          <ShareRegistrationLinkButton
            icon={<CustomIcon name="shareArrow" size={24} color={getMainColor(theme)} />}
          />
        </div>
      </div>
    </ModalSheet>
  );
}

export {RegisteredGuestsInfoModal};
